import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../core/models/response-api';
import { environment } from '../../environments/environment';
import { AppUtil } from '../core/utility/app-util';

export interface TransaccionEntity {
    correct: boolean;
    id: string;
    message: string;
}

export interface CarritoItemRequest {
    productoUuid: string;
    cantidad: number;
    fechaEntrega: string;
    rangoHorarioUuid: string;
    complementoUuids: string[];
}

export interface CarritoItemResponse {
    uuid: string;
    productoUuid: string;
    nombre: string;
    cantidad: number;
    precioUnitario: number;
    precioTotal: number;
    fechaEntrega: string | null;
    rangoHorarioUuid: string | null;
    urlImagen: string | null;
    complementos: string[];
}

export interface CarritoResponse {
    uuid: string;
    sesionToken: string | null;
    expiraAt: string | null;
    segundosRestantes: number;
    items: CarritoItemResponse[];
    subtotal: number;
}

@Injectable({
    providedIn: 'root'
})
export class CarritoBackService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/carrito';

    createCarrito(): Observable<ResponseApi<CarritoResponse>> {
        return this.http.post<ResponseApi<CarritoResponse>>(`${this.baseUrl}/create-carrito`, {});
    }

    getCarrito(carritoUuid: string): Observable<ResponseApi<CarritoResponse>> {
        return this.http.get<ResponseApi<CarritoResponse>>(`${this.baseUrl}/get-carrito/${carritoUuid}`);
    }

    claimCarrito(carritoUuid: string): Observable<ResponseApi<CarritoResponse>> {
        return this.http.post<ResponseApi<CarritoResponse>>(`${this.baseUrl}/claim-carrito/${carritoUuid}`, {});
    }

    addItem(carritoUuid: string, item: CarritoItemRequest): Observable<ResponseApi<TransaccionEntity>> {
        return this.http.post<ResponseApi<TransaccionEntity>>(`${this.baseUrl}/add-item/${carritoUuid}`, item);
    }

    updateItem(
        carritoUuid: string,
        itemUuid: string,
        item: CarritoItemRequest
    ): Observable<ResponseApi<TransaccionEntity>> {
        return this.http.put<ResponseApi<TransaccionEntity>>(
            `${this.baseUrl}/update-item/${carritoUuid}/${itemUuid}`,
            item
        );
    }

    removeItem(carritoUuid: string, itemUuid: string): Observable<ResponseApi<TransaccionEntity>> {
        return this.http.delete<ResponseApi<TransaccionEntity>>(
            `${this.baseUrl}/remove-item/${carritoUuid}/${itemUuid}`
        );
    }
}
